import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS, nightGray} from "@/shared/colors";
import {PD_LG, PD_XSM} from "@/shared/dimens";
import {SiteTemplate} from "../../types";
import {AddressSection} from "./AddressSection";
import {ContactSection} from "./ContactSection";
import {FaqSection} from "./FaqSection";
import {FooterSection} from "./FooterSection";
import {GallerySection} from "./GallerySection";
import {HeaderSection} from "./HeaderSection";
import {HeroSection} from "./HeroSection";
import {HighlightSection} from "./HighlightSection";
import {PromoSection} from "./PromoSection";
import {ServicesSection} from "./ServicesSection";
import {StatsSection} from "./StatsSection";
import {TeamSection} from "./TeamSection";
import {TestimonialsSection} from "./TestimonialsSection";
import {FontManager} from "@/shared/fonts";

const fontManager = FontManager.getInstance();
export const HeadingFont = fontManager.getFont("Urbanist");
export const BodyFont = fontManager.getFont("Outfit");

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  shape: {
    borderRadius: 8,
  },
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: "600",
          borderRadius: 8,
          minHeight: 48,
          paddingTop: PD_XSM,
          paddingBottom: PD_XSM,
          paddingLeft: PD_LG,
          paddingRight: PD_LG,
          textTransform: "none",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          backgroundColor: nightGray,
        },
        tooltip: {
          backgroundColor: nightGray,
          fontSize: "90%",
        },
      },
    },
  },
  typography: {
    h1: {
      fontWeight: "800",
      fontSize: "5rem",
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.0,
    },
    h2: {
      fontWeight: "800",
      fontSize: "3.4rem",
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.05,
    },
    h3: {
      fontWeight: "700",
      fontSize: "2.3rem",
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.1,
    },
    h4: {
      fontWeight: "700",
      fontSize: "1.5rem",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h5: {
      fontWeight: "700",
      fontSize: "1.2rem",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h6: {
      fontWeight: "600",
      fontSize: "1rem",
      fontFamily: HeadingFont.style.fontFamily,
    },
    fontSize: 17,
    fontFamily: BodyFont.style.fontFamily,
  },
  palette: {
    mode: "dark",
    background: {
      default: "#0D2918",
      paper: "#142E1E",
    },
    primary: {
      light: "#fff",
      main: "#fff",
      dark: "#fff",
      contrastText: "#000",
    },
    secondary: {
      main: "#C5F542",
      contrastText: "#0D2918",
    },
  }
};

export const OREGON_TEMPLATE: SiteTemplate = {
  name: "oregon",
  text: "Oregon",
  theme: createTheme(THEME_OPTIONS),
  themeExtras: {
    highlightColor: "#142E1E",
  },
  PageSections: {
    AddressSection: AddressSection,
    ContactSection: ContactSection,
    FaqSection: FaqSection,
    FooterSection: FooterSection,
    GallerySection: GallerySection,
    HeaderSection: HeaderSection,
    HeroSection: HeroSection,
    HighlightSection: HighlightSection,
    PromoSection: PromoSection,
    ServicesSection: ServicesSection,
    StatsSection: StatsSection,
    TeamSection: TeamSection,
    TestimonialsSection: TestimonialsSection,
  },
};
